import { z } from 'zod';

const blockServiceSchema = z.object({
  date: z.date({ required_error: 'schemas.common.dateRequired' }),
  time: z.array(z.object({ slot: z.string(), status: z.string() })),
  comments: z.string().optional()
});

export default blockServiceSchema;
